import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

const K: React.FC = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [src, setSrc] = useState('');

    const posters = [
        'https://websiteoss.ecoflow.com/upload/image/1773218441647/2-pc-1%20(1).jpg',
        'https://websiteoss.ecoflow.com/upload/image/1773197552600/2-m-1.jpg',
    ];
    const lines = t('K_title').split('\n');
    const [textT, setTextT] = useState(10);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let n = 10;
            let scaleSize = [0.62, 0.65];
            if (window.innerWidth >= 1680) {
                n = 8;
            } else if (window.innerWidth >= 1440) {
                n = 10;
            } else if (window.innerWidth >= 1024) {
                scaleSize = [0.48, 0.5]
                n = 11;
            } else if (window.innerWidth < 768) {
                scaleSize = [0.18, 0.2]
                n = 10;
            } else if (window.innerWidth < 1024) {
                scaleSize = [0.38, 0.4]
                n = 10;
            }
            setTextT(n);
            const sceneKArr: any[] = [];
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-H',
                    triggerHook: 1,
                    onEnter: () => {
                        setSrc(posters[0]);
                    },
                }),
            );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-K',
                    triggerHook: 1,
                    offset: '100%',
                    duration: '50%',
                    asyncFromTo: [
                        [`.delta-pro-ultra-K .icon-ani`, { opacity: 0, scale: 0.1 }, { opacity: 0.9, scale: scaleSize[0] }, 0.25],
                        [`.delta-pro-ultra-K .img-box`, { opacity: 1 }, { opacity: 1 }, 0.25],
                        [`.delta-pro-ultra-K .mask`, { opacity: 0 }, { opacity: 1 }, 0.25],
                        [`.delta-pro-ultra-K .icon-ani`, { opacity: 0.9, scale: scaleSize[0] }, { opacity: 1, scale: scaleSize[1] }, 0.2],
                        [`.delta-pro-ultra-K .img-box`, { opacity: 1 }, { opacity: 1 }, 0.2],
                        [`.delta-pro-ultra-K .mask`, { opacity: 1 }, { opacity: 1 }, 0.2],
                    ],
                    asyncTimeLine: [0, 0, 0, 0.25, 0.25, 0.25],
                }),
            );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-K',
                    triggerHook: 1,
                    offset: '135%',
                    duration: '125%',
                }),
            );


            return () => {
                sceneKArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-K dpu-K GtmModuleData-section`}
            id="delta-pro-ultra-K"
            data-section-id={'delta-pro-ultra-K'}
            data-section-title={t('K_title')}
        >
            <div className="sticky">
                <div className="img-box">
                    {src && <EcoImg pc={posters[0]} h5={posters[1]} isOpenLazy />}
                    <div className="mask" />
                </div>
                <div className="icon-box">
                    <div className="icon-ani">
                        <svg width="100%" height="100%" style={{ transform: 'scale(5)' }}>
                            {/* 黑色背景 */}
                            {/* <rect width="100%" height="100%" fill="black" /> */}

                            {/* 实心白字（不镂空） */}
                            {lines.map((line: string, index: number) => (
                                <text
                                    className={`svg-text svg-text-${index + 1}`}
                                    key={index}
                                    x="50%"
                                    y={`${50 + (index - (lines.length - 1) / 2) * textT}%`}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    fill="white" // ← 实心白色文字
                                    fontSize="24" // 可按需调整（px 或 SVG 单位）
                                    fontWeight="700"
                                >
                                    {line}
                                </text>
                            ))}
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default K;
